var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { LitElement, html, customElement, property, css } from 'lit-element';
import Auth from '@aws-amplify/auth';
import { Hub, ConsoleLogger } from '@aws-amplify/core';
const AUTHENTICATOR_AUTHSTATE = 'amplify-authenticator-authState';
const REDIRECTED_FROM_HOSTED_UI = 'amplify-redirected-from-hosted-ui';
const logger = new ConsoleLogger('Auth-logger');
const generateStateNonce = () => Math.random().toString(36).substr(2, 10);
let Authenticator = class Authenticator extends LitElement {
    constructor() {
        super();
        this.count = 0;
        this.handleStateChange = (newAuthState) => {
            if (newAuthState === this.authState) {
                return;
            }
            try {
                localStorage.setItem(AUTHENTICATOR_AUTHSTATE, newAuthState);
            }
            catch (e) {
                logger.error('Failed to set the auth state into local storage', e);
            }
            this.authState = newAuthState;
            const changeEvent = new CustomEvent('AuthStateChange', { detail: { newAuthState } });
            window.dispatchEvent(changeEvent);
            this.requestUpdate();
        };
        this.onHubCapsule = (capsule) => {
            const { channel } = capsule;
            const { payload } = capsule;
            if (channel === 'auth') {
                switch (payload.event) {
                    case 'cognitoHostedUI':
                        this.handleStateChange('signedIn');
                        break;
                    case 'cognitoHostedUI_failure':
                        this.handleStateChange('signIn');
                        break;
                    case 'parsingUrl_failure':
                        this.handleStateChange('signIn');
                        break;
                    case 'signOut':
                        this.handleStateChange('signIn');
                        break;
                    case 'customGreetingSignOut':
                        this.handleStateChange('signIn');
                        break;
                    case 'implicitFlow':
                        this.handleStateChange('loading');
                        break;
                    case 'customState_failure':
                        logger.error('customState_failure', capsule);
                        break;
                    case 'signIn':
                    case 'configured':
                        this.checkUser();
                        break;
                    default:
                        break;
                }
            }
        };
        this.triggerSignIn = () => {
            if (this.parsedConfig) {
                const stateNonce = generateStateNonce();
                let loginUrl = `https://${this.parsedConfig.oauth.domain}/oauth2/authorize?identity_provider=${this.parsedConfig.oauth.identityProvider}&client_id=${this.parsedConfig.oauth.clientId}&response_type=${this.parsedConfig.oauth.responseType}&scope=email+phone+openid+aws.cognito.signin.user.admin+profile&redirect_uri=${this.parsedConfig.oauth.redirectSignIn}`;
                loginUrl = `${loginUrl}&state=${stateNonce}`;
                const returnUrl = `${window.location.pathname}${window.location.search}`;
                localStorage.setItem(stateNonce, returnUrl);
                window.location.assign(loginUrl);
            }
        };
        this.amplifyConfig = '';
        this.authState = 'signIn';
    }
    static get styles() {
        return css `
      .loading-wrapper{
        width: 100vw;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    
      .loading-image{
        -webkit-animation:spin 1.5s linear infinite;
        -moz-animation:spin 1.5s linear infinite;
        animation:spin 1.5s linear infinite;
      }
      @-moz-keyframes spin { 100% { -moz-transform: rotate(360deg); } }
      @-webkit-keyframes spin { 100% { -webkit-transform: rotate(360deg); } }
      @keyframes spin { 100% { -webkit-transform: rotate(360deg); transform:rotate(360deg);
      }
    `;
    }
    connectedCallback() {
        super.connectedCallback();
        if (typeof this.amplifyConfig !== 'object') {
            try {
                this.parsedConfig = JSON.parse(this.amplifyConfig);
            }
            catch (error) {
                logger.error('Failed to parse amplifyConfig', error);
            }
        }
        Hub.listen('auth', this.onHubCapsule);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        Hub.remove('auth', this.onHubCapsule);
    }
    checkUser() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!Auth || typeof Auth.currentAuthenticatedUser !== 'function') {
                throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
            }
            try {
                const user = yield Auth.currentAuthenticatedUser();
                if (user) {
                    this.handleStateChange('signedIn');
                }
            }
            catch (err) {
                let cachedAuthState = null;
                try {
                    cachedAuthState = localStorage.getItem(AUTHENTICATOR_AUTHSTATE);
                }
                catch (e) {
                    logger.error('Failed to get the auth state from local storage', e);
                }
                if (cachedAuthState === 'signedIn') {
                    yield Auth.signOut();
                }
                this.handleStateChange('signIn');
            }
        });
    }
    render() {
        const redirectedFromHostedUI = localStorage.getItem(REDIRECTED_FROM_HOSTED_UI);
        localStorage.removeItem(REDIRECTED_FROM_HOSTED_UI);
        if (this.authState === 'signedIn') {
            return html `<div><slot></slot></div>`;
        }
        if (this.authState === 'signIn' && this.parsedConfig && !redirectedFromHostedUI) {
            this.triggerSignIn();
        }
        else {
            return html `<div class="loading-wrapper">
        <div class="loading-image">
          <svg xmlns="http://www.w3.org/2000/svg" width="87" height="82" viewBox="0 0 87 82">
            <g fill="#C5DA00" fill-rule="nonzero">
              <path
                d="M43.486 49.807c8.755 0 15.341 13.095 15.341 21.773 0 8.678-6.663 10.382-15.341 10.382-8.6 0-15.342-1.704-15.342-10.382 0-8.6 6.586-21.773 15.342-21.773zm0 3.022c-7.206 0-12.552 11.39-12.552 18.208 0 6.896 5.656 7.826 12.552 7.826 6.973 0 12.552-.93 12.552-7.826 0-6.818-5.346-18.208-12.552-18.208z"
                opacity=".3"
              />
              <path
                d="M32.961 40.768c0 8.755-13.094 15.341-21.772 15.341C2.51 56.11.806 49.446.806 40.768c0-8.6 1.705-15.342 10.383-15.342 8.6 0 21.772 6.586 21.772 15.342zm-3.022 0c0-7.206-11.39-12.552-18.208-12.552-6.896 0-7.825 5.656-7.825 12.552 0 6.973.93 12.552 7.825 12.552 6.819 0 18.208-5.346 18.208-12.552z"
                opacity=".1"
              />
              <path
                d="M54.01 40.768c0 8.755 13.095 15.341 21.773 15.341 8.678 0 10.382-6.663 10.382-15.341 0-8.6-1.704-15.342-10.382-15.342-8.6 0-21.773 6.586-21.773 15.342zm3.022 0c0-7.206 11.39-12.552 18.208-12.552 6.896 0 7.826 5.656 7.826 12.552 0 6.973-.93 12.552-7.826 12.552-6.818 0-18.208-5.346-18.208-12.552z"
                opacity=".6"
              />
              <path
                d="M43.486 32.374c8.755 0 15.341-13.094 15.341-21.772 0-8.678-6.663-10.383-15.341-10.383-8.6 0-15.342 1.705-15.342 10.383 0 8.6 6.586 21.772 15.342 21.772zm0-3.022c-7.206 0-12.552-11.39-12.552-18.208 0-6.896 5.656-7.826 12.552-7.826 6.973 0 12.552.93 12.552 7.826 0 6.818-5.346 18.208-12.552 18.208z"
              />
            </g>
          </svg>
        </div>
      </div>`;
        }
        return null;
    }
};
__decorate([
    property()
], Authenticator.prototype, "amplifyConfig", void 0);
__decorate([
    property()
], Authenticator.prototype, "parsedConfig", void 0);
__decorate([
    property()
], Authenticator.prototype, "authState", void 0);
__decorate([
    property({ type: Number })
], Authenticator.prototype, "count", void 0);
Authenticator = __decorate([
    customElement('authentication-wrapper')
], Authenticator);
export { Authenticator };
